import { onTrack } from '../event-listeners';
import { eventBus } from '../event-manager';
import JitsiMeetJS from '../lib-jitsi-meet';
import { useBaseStore, useParticipantStore, useTracksStore } from '../store';
import { EVENT_LISTENER_METHODS, MEDIA_TYPE } from '../utils';
import { sendParticipantEvent } from '../utils/send-participant-event';

export function startScreenSharing() {
  const desktopSharingFrameRate =
    useBaseStore.getState().desktopSharingFrameRate;
  JitsiMeetJS.createLocalTracks({
    devices: ['desktop'],
    desktopSharingFrameRate,
  })
    .then((tracks: any) => {
      const desktopVideoTrack = tracks.find(
        (track: any) => track.getType() === 'video',
      );
      const desktopAudioTrack = tracks.find(
        (track: any) => track.getType() === 'audio',
      );
      if (desktopAudioTrack) {
        // TODO: Handle audio track
        // We need to implement AudioMixer etc.
        desktopAudioTrack.dispose();
      }
      if (desktopVideoTrack) {
        onTrack(desktopVideoTrack);
      }
    })
    .catch((error: any) => {
      console.error('Error starting screen share:', error);
    });
}

export function stopScreenSharing() {
  useTracksStore.getState().updateLocalTrack(MEDIA_TYPE.SCREENSHARE, {
    muted: 1,
  });
}

export function addScreenShareParticipant(track: any) {
  if (!track || track.isMuted()) {
    return;
  }
  const participants = useParticipantStore.getState().participants;
  const localParticipant = useParticipantStore.getState().localParticipant;
  const participant = track.isLocal()
    ? localParticipant
    : participants.find(p => p.pid === track.getParticipantId());
  if (!participant) {
    console.error('Participant not found:', track.getParticipantId());
    return;
  }
  useParticipantStore.getState().addVirtualParticipant({
    ...participant,
    type: 'screen-share',
    name: participant.name,
    ruid: `${participant.pid}-screen-share`,
  });
  // Auto-pin the screen share participant
  useParticipantStore
    .getState()
    .pinParticipant(participant.pid, 'screen-share');
  if (track.isLocal()) {
    eventBus.publish({
      type: EVENT_LISTENER_METHODS.MediaEventsListener.onScreenShareStarted,
    });
  } else {
    sendParticipantEvent(
      EVENT_LISTENER_METHODS.ParticipantEventsListner
        .onParticipantStartedScreenShare,
      participant.pid,
    );
  }
}

export function removeScreenShareParticipant(participantId: string) {
  useParticipantStore
    .getState()
    .removeVirtualParticipant(participantId, 'screen-share');
  const localParticipantId =
    useParticipantStore.getState().localParticipant.pid;
  if (localParticipantId === participantId) {
    eventBus.publish({
      type: EVENT_LISTENER_METHODS.MediaEventsListener.onScreenShareStopped,
    });
  } else {
    sendParticipantEvent(
      EVENT_LISTENER_METHODS.ParticipantEventsListner
        .onParticipantStoppedScreenShare,
      participantId,
    );
  }
}
